import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
	padding: ${({padding}) => padding || '24px 20px'};
	color: ${({ theme }) => theme.colors.black};
	font-family: ${({ theme }) => theme.font};
	font-style: normal;
	border: 1px solid ${({ theme, borderColor }) => borderColor ? borderColor : theme.colors.grey};
	border-radius: 8px;
	min-height: 150px;
`;

export const CardHeader = styled.div`
	padding: ${({padding}) => padding};
	font-size: ${({fontSize}) => fontSize || '24px'};
    font-weight: 500;
    line-height: 30px;
`;

export const CardDescription = styled.div`
	font-size: ${({fontSize}) => fontSize || '16px'};
    font-weight: 400;
    line-height: 24px;
    padding: ${({padding}) => padding || '0px'};
    flex-grow: 1;
`;

export const CardReadMoreWrapper = styled.a`
    display: flex;
    align-items: center;
    gap: 10px;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 500;
    line-height: normal;
    font-size: ${({fontSize}) => fontSize || '18px'};
`;
